import { render, staticRenderFns } from "./PastProjectEditView.vue?vue&type=template&id=896d4782&"
import script from "./PastProjectEditView.vue?vue&type=script&lang=ts&"
export * from "./PastProjectEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896d4782')) {
      api.createRecord('896d4782', component.options)
    } else {
      api.reload('896d4782', component.options)
    }
    module.hot.accept("./PastProjectEditView.vue?vue&type=template&id=896d4782&", function () {
      api.rerender('896d4782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/past-project/PastProjectEditView.vue"
export default component.exports